import { render } from "./TPPWidgetWrapper.vue?vue&type=template&id=5baa13bc&scoped=true"
import script from "./TPPWidgetWrapper.vue?vue&type=script&lang=js"
export * from "./TPPWidgetWrapper.vue?vue&type=script&lang=js"

import "./TPPWidgetWrapper.vue?vue&type=style&index=0&id=5baa13bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baa13bc"]])

export default __exports__